import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 20 16.12",
  "content": "<symbol viewBox=\"0 0 20 16.12\" id=\"refresh\"><title>refresh</title><path d=\"M13.63,17.06l-1.52-.4H12a7.07,7.07,0,0,1-7.77-3.21,6.65,6.65,0,0,1-.83-2.3l0-.2a.36.36,0,0,1,.44-.4l.71.19a.16.16,0,0,0,.19-.2L3.53,6.31a.16.16,0,0,0-.11-.11h0a.16.16,0,0,0-.11,0L.05,9.3a.16.16,0,0,0,.07.27l2,.53,0,.36A7.69,7.69,0,0,0,3.22,14a8.26,8.26,0,0,0,10.43,3.34.15.15,0,0,0,.09-.16A.16.16,0,0,0,13.63,17.06Z\" transform=\"translate(0 -1.94)\" /><path d=\"M19.88,10.65l-1.38-.36V9.91A7.69,7.69,0,0,0,17.44,6,8.25,8.25,0,0,0,6.92,2.68a.15.15,0,0,0-.09.16A.16.16,0,0,0,6.95,3l1.47.39H8.5a7,7,0,0,1,7.9,3.19,6.62,6.62,0,0,1,.89,2.73l0,.19a.36.36,0,0,1-.45.38l-1-.27h0a.16.16,0,0,0-.15.2l1.12,3.86a.16.16,0,0,0,.26.07L20,10.92h0a.16.16,0,0,0-.07-.27Z\" transform=\"translate(0 -1.94)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/refresh.svg
// module id = wK1c
// module chunks = 264